var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 14V36.5M21.9999 14L29.4999 21.5M21.9999 14L14.4999 21.5M35.7499 26.5C39.5474 26.5 41.9999 23.4225 41.9999 19.625C41.9998 18.1216 41.5068 16.6596 40.5965 15.4631C39.6863 14.2665 38.4088 13.4013 36.9599 13C36.737 10.1962 35.5749 7.54946 33.6616 5.48777C31.7483 3.42608 29.1956 2.06994 26.4162 1.6386C23.6367 1.20726 20.7931 1.72593 18.3449 3.11076C15.8967 4.49559 13.9872 6.66563 12.9249 9.27004C10.6885 8.65009 8.29737 8.94396 6.2776 10.087C4.25784 11.23 2.77486 13.1286 2.15492 15.365C1.53497 17.6015 1.82884 19.9926 2.97188 22.0124C4.11491 24.0321 6.01348 25.5151 8.24992 26.135",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudeIco);
export default __webpack_public_path__ + "static/media/cloude-ico.b98c03054cb12cb45c7618374834263a.svg";
export { ForwardRef as ReactComponent };